import React, { useState, useEffect } from 'react';
import { getSettings } from '../services/api';

function SyncStatusBanner() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    getSettings()
      .then((settings) => {
        if (!cancelled) setItems(Array.isArray(settings?.banner) ? settings.banner : []);
      })
      .catch((err) => console.error('Sync-Status konnte nicht geladen werden:', err));
    return () => {
      cancelled = true;
    };
  }, []);

  if (items.length === 0) return null;

  const sorted = [...items].sort(
    (a, b) => (a.level === 'error' ? 0 : 1) - (b.level === 'error' ? 0 : 1)
  );

  return (
    <div className="sync-banners">
      {sorted.map((item, i) => {
        const isError = item.level === 'error';
        return (
          <div
            key={`${item.level}-${i}`}
            className={`sync-banner sync-banner--${isError ? 'error' : 'warning'}`}
            role={isError ? 'alert' : 'status'}
          >
            {item.message}
          </div>
        );
      })}
    </div>
  );
}

export default SyncStatusBanner;
